module.exports = __webpack_public_path__ + "img/watering-can.48c3c340.png";